module.exports = __webpack_public_path__ + "img/whatsApp.3d1bfdde.png";